import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  Button,
  InputAdornment,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { Card, Tag, Typography as typography_antd } from "antd";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import "./index.css";
import ApplyLeaveStyle from "../../Components/ApplyLeaveStyle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import env from "../../config/env";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchUserData } from "../../redux/slice/userData";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import CryptoJS from "crypto-js";

const { Title } = typography_antd;

const initialUserDetails = {
  name: "",
  designation: "",
  company_email: "",
  personal_email: "",
  gender: "",
  phone_no: "",
  address: "",
  alternate_no: "",
  dob: null,
  profile_pic: "",
  identity_pic: "",
  aadhar_no: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  bank_name: "",
  account_number: "",
  branch_name: "",
  bank_ifsc: ""
};

export default function Profile(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userDefaultDetails, setUserDefaultDetails] = useState(initialUserDetails);
  const [fileName, setFileName] = useState("");
  const [url, setUrl] = useState("");
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [errorText, setErrorText] = useState({
    gender: "",
    phone_no: "",
    address: "",
    personal_email: "",
    alternate_no: "",
    aadhar_no: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    bank_name: "",
    account_number: "",
    branch_name: "",
    bank_ifsc: ""
  });
  const [file, setFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [profileImg, setProfileImg] = useState("");
  const [identityImg, setIdentityImg] = useState("");
  const [identityVal, setIdentityVal] = useState("");
  const [identityLoader, setIdentityLoader] = useState(true);
  const [profileLoader, setProfileLoader] = useState(true);
  const [count, setCount] = useState(0);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const token = useSelector((state) => state.auth.token);
  let userData = useSelector((state) => state.auth.userData);

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  // function encryptData(data) {
  //   const ciphertext = 
  //   return ciphertext;
  // }

  // useEffect(() => {
  //   if (token) {
  //     dispatch(fetchUserData(props?.userData?.id));
  //   }
  // }, [token, count]);

  useEffect(() => {
    if (userData) {
      setUserDefaultDetails(userData);
      setLoading(false);
      setpreventDoubleClick(false);
    }
  }, [userData]);

  // useEffect(() => {
  //   if (identityVal) {
  //     handleFileUpload();
  //   }
  // }, [identityVal]);

  // useEffect(() => {
  //   setIdentityLoader(false);
  // }, [userDefaultDetails?.identity_pic, identityImg]);

  // useEffect(() => {
  //   setProfileLoader(false);
  // }, [userDefaultDetails?.profile_pic, profileImg]);

  const handleProfilePic = (event) => {
    const selectedFile = event.target.files[0];
    setProfileFile(selectedFile);
    setIdentityVal("Profile");
  };

  const handleIdentityPic = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setIdentityVal("Identity");
  };

  const handleFileUpload = async (fileData) => {
    const formData = new FormData();
    formData.append("file", fileData);
    let tempData = "";
    await axios
      .post(`${env.backend_api_endpoint}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // setImageUrl(response.data.filename);
        // if (identityVal === "Profile") {
        //   setProfileImg(response.data.filename);
        //   setUserDefaultDetails({
        //     ...userDefaultDetails,
        //     profile_pic: response?.data?.fileName,
        //   });
        //   setProfileLoader(false);
        // }
        // if (identityVal === "Identity") {
        //   setIdentityImg(response.data.filename);
        //   setUserDefaultDetails({
        //     ...userDefaultDetails,
        //     identity_pic: response?.data?.fileName,
        //   });
        //   setIdentityLoader(false);
        // }
        // toast.success("Uploaded successfully!", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   toastId: "1",
        // });
        tempData = response.data.filename
      })
      .catch((error) => {
        console.log(error.response.data.error);
      });
    return tempData
  };

  const validateFields = () => {
    let errorObj = {
      gender: "",
      phone_no: "",
      address: "",
      personal_email: "",
      alternate_no: "",
      dob: "",
    };

    if (!userDefaultDetails?.gender) {
      errorObj.gender = "Gender is required!";
    }

    if (!userDefaultDetails?.phone_no) {
      errorObj.phone_no = "Please input your phone number!";
    }

    else if (!/^[0-9]{10}$/.test(userDefaultDetails?.phone_no)) {
      errorObj.phone_no = "Please enter a 10-digit mobile number!";
    }

    if (!userDefaultDetails?.address) {
      errorObj.address = "Please input your Address!";
    }

    if (!userDefaultDetails?.dob) {
      errorObj.dob = "Please input your Date of Birth!";
    }

    if (userDefaultDetails?.personal_email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(userDefaultDetails?.personal_email)) {
      errorObj.personal_email = "Please enter a valid email address!";
    }

    if (userDefaultDetails?.alternate_no && !/^[0-9]{10}$/.test(userDefaultDetails?.alternate_no)) {
      errorObj.alternate_no = "Please enter a 10-digit mobile number!";
    }

    if (!userDefaultDetails?.aadhar_no) {
      errorObj.aadhar_no = "Please input your Adhar Card Number";
    }

    if (userDefaultDetails?.aadhar_no && !/^\d{12}$/.test(userDefaultDetails?.aadhar_no)) {
      errorObj.aadhar_no = "Please input 12-digit Adhar Card Number";
    }

    if (!profileFile && !userDefaultDetails?.profile_pic) {
      errorObj.profileImg = "Please input your Profile Image";
    }

    if (!file && !userDefaultDetails?.identity_pic) {
      errorObj.identityImg = "Please input your Identity Image";
    }

    if (!userDefaultDetails?.salary > 0) {
      if (!userDefaultDetails?.first_name) {
        errorObj.first_name = "Please input your First Name";
      }

      if (!userDefaultDetails?.last_name) {
        errorObj.last_name = "Please input your Last Name";
      }

      if (!userDefaultDetails?.middle_name) {
        errorObj.middle_name = "Please input your Middle Name";
      }

      if (!userDefaultDetails?.bank_name) {
        errorObj.bank_name = "Please input your Bank Name";
      }

      if (!userDefaultDetails?.branch_name) {
        errorObj.branch_name = "Please input your Branch Name";
      }

      if (!userDefaultDetails?.account_number) {
        errorObj.account_number = "Please input your Account Number";
      }

      if (!userDefaultDetails?.bank_ifsc) {
        errorObj.bank_ifsc = "Please input your Bank IFSC Code";
      }

      if (userDefaultDetails.account_number && !/^[0-9]{9,18}$/.test(userDefaultDetails.account_number)) {
        errorObj.account_number = "Please enter a proper Account Nnumber!";
      }

      if (
        userDefaultDetails.bank_ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(userDefaultDetails.bank_ifsc)) {
        errorObj.bank_ifsc = "Please enter a proper Bank IFSC Code!";
      }
    }

    setErrorText({ ...errorObj });
    return !Object.values(errorObj).some((error) => error);
  };

  const onFinish = async () => {
    let profileImgUrl = '';
    let identityFileurl = '';
    if (validateFields()) {
      try {
        if (profileFile !== null) {
          profileImgUrl = await handleFileUpload(profileFile)
        }
        if (file !== null) {
          identityFileurl = await handleFileUpload(file);
        }
        setpreventDoubleClick(true);
        const app = {
          ...userDefaultDetails,
          personalEmail: userDefaultDetails?.personal_email || null,
          phoneNo: userDefaultDetails.phone_no,
          alternateNo: userDefaultDetails?.alternate_no || "",
          dob: userDefaultDetails.dob,
          address: userDefaultDetails.address,
          gender: userDefaultDetails.gender,
          adharCardNo: userDefaultDetails.aadhar_no,
          profileImg:
            profileImgUrl !== "" ? profileImgUrl : userDefaultDetails.profile_pic,
          identityProof:
            identityFileurl !== "" ? identityFileurl : userDefaultDetails.identity_pic,
          firstName: userDefaultDetails.first_name,
          middleName: userDefaultDetails.middle_name,
          lastName: userDefaultDetails.last_name,
          bankName: userDefaultDetails.bank_name,
          accountNumber: userDefaultDetails.account_number,
          branchName: userDefaultDetails.branch_name,
          bankIFSC: userDefaultDetails.bank_ifsc
        };

        setUserDefaultDetails(app);

        try {

          // Prepare plain data
          const plainData = {
            userId: props?.userData.id,
            personalEmail: userDefaultDetails.personal_email || "",
            phoneNo: userDefaultDetails.phone_no,
            alternateNo: userDefaultDetails.alternate_no || "",
            dob: userDefaultDetails.dob,
            address: userDefaultDetails.address,
            gender: userDefaultDetails.gender,
            aadharNo: userDefaultDetails.aadhar_no,
            profilePic: profileImgUrl !== "" ? profileImgUrl : userDefaultDetails.profile_pic,
            identityPic: identityFileurl !== "" ? identityFileurl : userDefaultDetails.identity_pic,
            firstName: userDefaultDetails.first_name,
            middleName: userDefaultDetails.middle_name,
            lastName: userDefaultDetails.last_name,
            bankName: userDefaultDetails.bank_name,
            accountNumber: userDefaultDetails.account_number,
            branchName: userDefaultDetails.branch_name,
            bankIFSC: userDefaultDetails.bank_ifsc
          };

          // Encrypt data
          const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(plainData), SECRET_KEY).toString();;

          //Encrypt api endpoint
          const updateProfile = CryptoJS.SHA256("/updateProfile" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

          const response = await fetch(
            `${env.backend_api_endpoint}/${updateProfile}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: token,
              },
              body: JSON.stringify({ encryptedData: encryptedBody }),

              // body: JSON.stringify({
              //   userId: props?.userData.id,
              //   personalEmail: userDefaultDetails.personal_email || "",
              //   phoneNo: userDefaultDetails.phone_no,
              //   alternateNo: userDefaultDetails.alternate_no || "",
              //   dob: userDefaultDetails.dob,
              //   address: userDefaultDetails.address,
              //   gender: userDefaultDetails.gender,
              //   aadharNo: userDefaultDetails.aadhar_no,
              //   profilePic:
              //     profileImgUrl !== "" ? profileImgUrl : userDefaultDetails.profile_pic,
              //   identityPic:
              //     identityFileurl !== ""
              //       ? identityFileurl
              //       : userDefaultDetails.identity_pic,
              //   firstName: userDefaultDetails.first_name,
              //   middleName: userDefaultDetails.middle_name,
              //   lastName: userDefaultDetails.last_name,
              //   bankName: userDefaultDetails.bank_name,
              //   accountNumber: userDefaultDetails.account_number,
              //   branchName: userDefaultDetails.branch_name,
              //   bankIFSC: userDefaultDetails.bank_ifsc
              // }),
            }
          );

          if (!response.ok) {
            const errorData = await response.json();

            if (errorData.status === 555 || errorData.status === 501) {
              dispatch(setToken(null));
              dispatch(setUserData(null));
              toast.error("Session expire, Please LogIn!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });
              Navigate("/login")
            }
          }

          if (response.ok) {

            const successData = await response.json();

            if (successData.status === 200 && successData.encryptedData) {

              // Decrypt backend response
              const bytes = CryptoJS.AES.decrypt(successData.encryptedData, SECRET_KEY);
              const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

              toast.success("Changes saved successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });
              dispatch(setUserData({
                ...userData,
                profile_pic: decryptedData?.profile_pic,
                identity_pic: decryptedData?.identity_pic,
                personal_email: decryptedData?.personal_email,
                dob: decryptedData?.dob,
                gender: decryptedData?.gender,
                phone_no: decryptedData?.phone_no,
                alternate_no: decryptedData?.alternate_no,
                address: decryptedData?.address,
                aadhar_no: decryptedData?.aadhar_no,
                first_name: decryptedData?.first_name,
                middle_name: decryptedData?.middle_name,
                last_name: decryptedData?.last_name,
                account_number: decryptedData?.account_number,
                bank_ifsc: decryptedData?.bank_ifsc,
                bank_name: decryptedData.bank_name,
                branch_name: decryptedData?.branch_name
              }));;
              setFileName("");
              setUrl("");
              setCount(count + 1)
              setpreventDoubleClick(false)

              // window.location.reload();
            }
          }
        } catch (error) {
          console.error("Error  Upadate Profile in:", error.message);
        }
      }
      catch (err) {
        console.log("upload api error", err)
      }
    }
  };

  const pdfHandler = () => {
    window.open(userDefaultDetails.resume, "_blank");
  };

  return (
    <ApplyLeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bordered={false}
          bodyStyle={{ height: "calc(100vh - 78px)", overflow: "auto", padding: "12px" }}
          style={{
            margin: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              marginTop: "3px",
              fontFamily: "ImportedMilliardBold",
            }}
          >
            <Title
              level={2}
              style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", fontWeight: 500 }}
            >
              Profile
            </Title>
          </div>

          {!loading ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <Typography className="label_text_profile" >
                    Upload Profile Picture{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <label
                    htmlFor="upload-photo"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "155px",

                    }}
                  >
                    <input
                      style={{ display: "none" }}
                      id="upload-photo"
                      name="upload-photo"
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        handleProfilePic(e);
                      }}
                    />
                    {userDefaultDetails?.profile_pic || profileFile !== null ? (
                      <div
                        style={{
                          height: "70px",
                          width: "70px",
                          backgroundColor: "#8080805e",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* {!profileLoader ?
                        <> */}


                        <img
                          style={{
                            height: "70px",
                            width: "70px",
                            borderRadius: "50%",
                            border: "1px solid"
                          }}
                          // src={`${env.backend_api_endpoint}/files/${
                          //   profileImg
                          //     ? profileImg
                          //     : userDefaultDetails?.profile_pic
                          // }`}
                          src={profileFile !== null ?
                            URL.createObjectURL(profileFile)
                            : `${env.backend_api_endpoint}/files/${userDefaultDetails?.profile_pic}`
                          }
                          alt={`${userDefaultDetails?.profile_pic}`}
                        />
                      </div>
                    ) : (
                      // <AddIcon style={{ fontSize: "40px" }} /> */}
                      <Tag
                        style={{
                          borderRadius: "60px",
                          fontWeight: "bold",
                          border: "1px solid",
                          height: "70px",
                          width: "70px",
                          fontSize: "30px",
                          backgroundColor: "#c8e4fc",
                          color: "navy",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {userDefaultDetails?.name?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")}
                      </Tag>
                    )}
                    {/* </>
                        :
                        <div>  <CircularProgress />
                        </div>
                      }*/}
                    {/* </div> */}
                  </label>

                </div>
              </div>

              <div className="profileItem">
                <Title
                  level={4}
                  style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", marginBottom: "0px" }}
                >
                  Personal Details
                </Title>

                <div></div>

                <div>
                  <Typography className="label_text_profile">
                    Name <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <TextField
                    placeholder="Name"
                    value={userDefaultDetails?.name}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Designation <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    placeholder="Enter Designation"
                    value={userDefaultDetails?.designation}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Email <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <TextField
                    placeholder="Enter Company Email"
                    value={userDefaultDetails?.company_email}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Personal Email{" "}
                  </Typography>

                  <TextField
                    placeholder="Enter Personal Email"
                    value={userDefaultDetails?.personal_email}
                    autoComplete="off"

                    onChange={(e) => {
                      setErrorText({ personal_email: "" });
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        personal_email: e.target.value,
                      });
                    }}
                    error={errorText.personal_email}
                    helperText={errorText.personal_email}
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Date Of Birth <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className={`Dob ${errorText.dob ? "error" : ""}`}
                      fullWidth
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          inputProps: {
                            sx: {
                              padding: '11px 14px',
                              fontSize: '14px',
                            },
                          },
                          InputProps: {
                            sx: {
                              fontSize: '14px',
                              height: '40px',
                              '& .MuiButtonBase-root .MuiSvgIcon-root': {
                                color: '#6b7280',
                                fill: '#6b7280',
                                opacity: 1,
                              },
                            },
                          },
                        },
                      }}
                      format="DD-MM-YYYY"
                      value={
                        userDefaultDetails?.dob
                          ? dayjs(userDefaultDetails?.dob)
                          : null
                      }
                      onChange={(e) => {
                        setErrorText({
                          ...errorText,
                          dob: "",
                        });
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          dob: e.format("YYYY-MM-DD"),
                        });
                      }}
                      error={errorText.Dob}
                    />
                  </LocalizationProvider>
                  <FormHelperText style={{ color: "red" }}>
                    {errorText.dob}
                  </FormHelperText>
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Gender <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="radio-buttons-group"
                    defaultValue={userDefaultDetails?.gender}
                    // sx={{
                    //     "& .MuiFormControlLabel-label": {
                    //       fontFamily: "Milliard",
                    //     },
                    // }}
                    onChange={(e) => {
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        gender: e.target.value,
                      });
                    }}
                  >
                    <FormControlLabel
                      key="Male"
                      value="Male"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      key="Female"
                      value="Female"
                      control={<Radio />}
                      label="Female"
                    />
                  </RadioGroup>
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    placeholder="Enter Phone Number"
                    fullWidth
                    size="small"
                    value={userDefaultDetails?.phone_no}
                    type="number"
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"
                          sx={{
                            marginRight: '5px',
                            backgroundColor: '#f2f4f7',       // Light grey background
                            padding: '19px 12px',              // Padding for spacing
                            borderRight: '1px solid #ccc',    // Right border
                            borderTopLeftRadius: '4px',
                            borderBottomLeftRadius: '4px',
                            fontSize: '14px',
                            color: '#333',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >+91</InputAdornment>
                      ),
                    }}
                    autoComplete="off"
                    sx={{
                      // target the root of the outlined input when it's disabled
                      "& .MuiOutlinedInput-root": {
                        paddingLeft: 0,
                      },
                    }}
                    onChange={(e) => {
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        phone_no: e.target.value,
                      });
                      if (e.target.value !== "") {
                        setErrorText({
                          ...errorText,
                          phone_no: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          phone_no: "Please input your phone number!",
                        });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric", // Ensures mobile keyboards show numbers
                      pattern: "[0-9]*", // Allows only digits
                      min: 0, // Ensures the value can't be negative
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    error={errorText.phone_no}
                    helperText={errorText.phone_no}
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Alternate Number
                  </Typography>
                  <TextField
                    placeholder="Enter Alternate Phone Number"
                    fullWidth
                    size="small"
                    value={userDefaultDetails?.alternate_no}
                    type="number"
                    autoComplete="off"
                    sx={{
                      // target the root of the outlined input when it's disabled
                      "& .MuiOutlinedInput-root": {
                        paddingLeft: 0,
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"
                          sx={{
                            marginRight: '5px',
                            backgroundColor: '#f2f4f7',       // Light grey background
                            padding: '19px 12px',              // Padding for spacing
                            borderRight: '1px solid #ccc',    // Right border
                            borderTopLeftRadius: '4px',
                            borderBottomLeftRadius: '4px',
                            fontSize: '14px',
                            color: '#333',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >+91</InputAdornment>
                      ),
                    }}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    onChange={(e) => {
                      setErrorText({ alternate_no: "" });
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        alternate_no: e.target.value,
                      });
                    }}
                    onKeyDown={(e) => {
                      if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric", // Ensures mobile keyboards show numbers
                      pattern: "[0-9]*", // Allows only digits
                      min: 0, // Ensures the value can't be negative
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    error={errorText.alternate_no}
                    helperText={errorText.alternate_no}
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Adhar Card Number
                    <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <TextField
                    placeholder="Adhar Card Number"
                    type="number"
                    value={userDefaultDetails?.aadhar_no}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 12))
                    }
                    inputProps={{
                      inputMode: "numeric", // Ensures mobile keyboards show numbers
                      pattern: "[0-9]*", // Allows only digits
                      min: 0, // Ensures the value can't be negative
                    }}
                    onKeyDown={(e) => {
                      if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value !== "") {
                        setErrorText({
                          ...errorText,
                          aadhar_no: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          aadhar_no: "Please input your Adhar No!",
                        });
                      }
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        aadhar_no: e.target.value,
                      });
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    error={errorText.aadhar_no}
                    helperText={errorText.aadhar_no}
                    fullWidth
                    size="small"
                  />
                </div>

                <div style={{ display: "flex" }}>
                  <div>
                    <Typography className="label_text_profile">
                      Upload Identity Proof
                      <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <label
                      htmlFor="upload-identity-photo"
                      style={{ display: "flex", width: "155px" }}
                    >
                      <input
                        style={{ display: "none" }}
                        id="upload-identity-photo"
                        name="upload-identity-photo"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          handleIdentityPic(e);
                        }}
                      />

                      <Button
                        startIcon={<FileUploadIcon />}
                        variant="contained"
                        component="span"
                        style={{ backgroundColor: "rgb(36,77,160)", fontFamily: "MilliardMedium" }}
                      >
                        Upload File
                      </Button>
                    </label>
                  </div>
                  {/* {!userDefaultDetails?.identity_pic && file == null ? ( */}
                  {(userDefaultDetails?.identity_pic || file !== null) && (
                    <img
                      style={{
                        height: "70px",
                        width: "100px",
                        marginTop: "10px",
                        marginLeft: "10px",
                        objectFit: "fill",
                      }}
                      // src={`${env.backend_api_endpoint}/files/${identityImg
                      //     ? identityImg
                      //     : userDefaultDetails?.identity_pic
                      //   }`}
                      // alt={`${identityImg
                      //     ? identityImg
                      //     : userDefaultDetails?.identity_pic
                      //   }`}

                      src={file !== null ?
                        URL.createObjectURL(file)
                        : `${env.backend_api_endpoint}/files/${userDefaultDetails?.identity_pic}`
                      }
                      alt={`${userDefaultDetails?.identity_pic}`}
                    />
                  )}
                  {/* ) : (
                    <div
                      style={{
                        height: "70px",
                        width: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginLeft: "10px",
                        objectFit: "fill",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )} */}
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Address <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    placeholder="Enter Address"
                    size="small"
                    fullWidth
                    value={userDefaultDetails?.address}
                    multiline
                    rows={2}
                    autoComplete="off"
                    onChange={(e) => {
                      setUserDefaultDetails({
                        ...userDefaultDetails,
                        address: e.target.value,
                      });
                      if (e.target.value !== "") {
                        setErrorText({
                          ...errorText,
                          address: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          address: "Please input your Address!",
                        });
                      }
                    }}
                    error={errorText.address}
                    helperText={errorText.address}
                  />
                </div>

                <div></div>

                {userData.salary > 0 &&
                  <>
                    <Title
                      level={4}
                      style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", marginBottom: "0px", marginTop: "20px" }}
                    >
                      Bank Details
                    </Title>
                    <div></div>
                    <div>
                      <Typography className="label_text_profile">
                        First Name
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="First Name"
                        type="text"
                        value={userDefaultDetails?.first_name}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              first_name: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              first_name: "Please input your First Name!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            first_name: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.first_name}
                        helperText={errorText.first_name}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Middle Name
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Middle Name"
                        type="text"
                        value={userDefaultDetails?.middle_name}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              middle_name: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              middle_name: "Please input your Middle Name!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            middle_name: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.middle_name}
                        helperText={errorText.middle_name}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Last Name
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Last Name"
                        type="text"
                        value={userDefaultDetails?.last_name}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              last_name: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              last_name: "Please input your Last Name!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            last_name: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.last_name}
                        helperText={errorText.last_name}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Bank Name
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Bank Name"
                        type="text"
                        value={userDefaultDetails?.bank_name}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              bank_name: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              bank_name: "Please input your Bank Name!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            bank_name: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.bank_name}
                        helperText={errorText.bank_name}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Account Number
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Account Number"
                        type="number"
                        value={userDefaultDetails?.account_number ? userDefaultDetails.account_number : undefined}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              account_number: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              account_number: "Please input your Account Number!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            account_number: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.account_number}
                        helperText={errorText.account_number}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Branch Name
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Branch Name"
                        type="text"
                        value={userDefaultDetails?.branch_name}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              branch_name: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              branch_name: "Please input your Branch Name!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            branch_name: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.branch_name}
                        helperText={errorText.branch_name}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div>
                      <Typography className="label_text_profile">
                        Bank IFSC Code
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Bank IFSC Code"
                        type="text"
                        value={userDefaultDetails?.bank_ifsc}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setErrorText({
                              ...errorText,
                              bank_ifsc: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              bank_ifsc: "Please input your Bank IFSC Code!",
                            });
                          }
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            bank_ifsc: e.target.value,
                          });
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                        error={errorText.bank_ifsc}
                        helperText={errorText.bank_ifsc}
                        fullWidth
                        size="small"
                      />
                    </div>
                  </>
                }
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <LoadingButton
                  className="profile_btn"
                  size="large"
                  variant="contained"
                  id="submit_btn"
                  onClick={onFinish}
                  loading={preventDoubleClick}
                  block
                  style={{
                    backgroundColor: "rgb(36,77,160)",
                    marginTop: "25px",
                    height: "44px",
                    width: "130px",
                    fontFamily: "MilliardMedium"
                  }}
                >
                  <span>{preventDoubleClick ? "" : "Submit"}</span>
                </LoadingButton>
              </div>
            </>
          ) : (
            <span
              class="loader"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            ></span>
          )
          }
        </Card >
      </div >
    </ApplyLeaveStyle >
  );
}
